function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.18 18.066H.82a.821.821 0 01-.82-.82V9.405a.492.492 0 11.984 0v7.677h18.033V9.405a.492.492 0 11.984 0v7.841a.821.821 0 01-.821.82z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.508 9.9a.492.492 0 01-.474-.361l-1.8-6.552H2.768l-1.8 6.552a.492.492 0 01-.948-.261l1.9-6.913a.492.492 0 01.474-.361h15.213a.491.491 0 01.474.361l1.9 6.913a.492.492 0 01-.344.6.483.483 0 01-.129.022z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 13.147a3.83 3.83 0 01-3.737-3.279H.492a.492.492 0 010-.984h6.23a.492.492 0 01.492.492 2.787 2.787 0 105.574 0 .492.492 0 01.492-.492h6.23a.492.492 0 010 .984h-5.772A3.83 3.83 0 0110 13.147z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
});

var SvgInbox = function SvgInbox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 20 20",
      width: 20,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgInbox, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Inbox.48944146.svg";
export { ForwardRef as ReactComponent };